import { useEffect } from 'react';

export function useNetworkContainer(isMobile: boolean, isMobileDeviceResized: boolean) {
  useEffect(() => {
    const networksContainer = document.getElementById('networks-container');
    if (!networksContainer == null) return;

    let isNetworksContainerActive = false;
    let slideIndex = 0;

    const maxScrollIndex = networksContainer.scrollWidth - networksContainer.offsetWidth;

    const handleWheel = (event: WheelEvent) => {
      if (event.deltaX !== 0 && event.deltaY === 0) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (isNetworksContainerActive && (isMobile || isMobileDeviceResized)) {
        event.preventDefault();
        slideIndex = Math.max(0, Math.min(slideIndex + (event.deltaY > 0 ? 1 : -1), maxScrollIndex / 10 - 1));
        networksContainer?.scrollTo({ left: slideIndex * 10 });
      }
    };

    const handleMouseMove = (event: MouseEvent) => {
      isNetworksContainerActive = networksContainer.contains(event.target as Node);
    };

    const handleScroll = (event: Event) => {
      if (isNetworksContainerActive) event.preventDefault();
    };

    networksContainer?.addEventListener('wheel', handleWheel, { passive: false });
    window.addEventListener('mousemove', handleMouseMove);
    networksContainer?.addEventListener('scroll', handleScroll, { passive: false });

    return () => {
      networksContainer?.removeEventListener('wheel', handleWheel);
      window.removeEventListener('mousemove', handleMouseMove);
      networksContainer?.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile, isMobileDeviceResized]);
}
